import React from "react";
import { ProductResultGroup, Widget } from "@/types";
import { ProductCarouselWidget } from "@/components/widgets/ProductCarouselWidget";
import { WebProductCarouselWidget } from "@/components/widgets/WebProductCarouselWidget";
import { useGamesPortalStore } from "@/features/games-portal";

interface WidgetMessageProps {
  widgets: Widget[];
  selectedModel?: string;
  onModelSelect?: (model: Widget) => void;
  canSelectModel: boolean;
  products?: any[]; // TODO: Add proper type
  productIds?: string[]; // 🆕 VectorSearch'ten gelen product ID'leri
  offerMap?: Record<string, string>;
  filterOptions?: Record<string, string[]>; // 🆕 VectorSearch'ten gelen filterOptions
  resultGroups?: ProductResultGroup[];
}

export const WidgetMessage: React.FC<WidgetMessageProps> = ({
  widgets,
  products,
  productIds,
  offerMap,
  filterOptions,
  resultGroups,
}) => {
  const openPortal = useGamesPortalStore((state) => state.openPortal);
  const hasGameSystemWidget = widgets.some((w) => w.key === "game-system");
  const hasResultGroups = resultGroups && resultGroups.length > 0;

  React.useEffect(() => {
    if (hasGameSystemWidget) {
      openPortal({ view: "menu" });
    }
  }, [hasGameSystemWidget, openPortal]);

  return (
    <div className="space-y-4">
      {/* Products Widget - Updated with ProductCarouselWidget */}
      {hasResultGroups &&
        resultGroups.map((group, index) => (
          <section
            key={`${group.recipient}:${group.label}:${index}`}
            className="space-y-2"
          >
            {group.productIds.length > 0 && (
              <ProductCarouselWidget
                productIds={group.productIds}
                offerMap={group.offerMap}
                filterOptions={group.filterOptions}
                discoverQuery={group.discoverQuery}
              />
            )}
            {/* Katalogda karşılığı yoksa isteğin cevabı web'den gelir; yine
                kendi şeridinde durur. */}
            {group.webProducts && group.webProducts.length > 0 && (
              <WebProductCarouselWidget
                products={group.webProducts}
                query={group.webQuery}
              />
            )}
          </section>
        ))}
      {!hasResultGroups &&
      ((products && products.length > 0) ||
        (productIds && productIds.length > 0)) ? (
        <ProductCarouselWidget
          productIds={productIds}
          offerMap={offerMap}
          filterOptions={filterOptions}
        />
      ) : null}
    </div>
  );
};
